import styled from 'styled-components';

export const Container = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  border: none;
  background: none;
  margin-left: 12px;
  justify-content:center;

  span {
    font-size: var(--font-default);
    font-weight: 500;
    color: var(--primary-color);
  }

  svg {
    margin: 0 10px 0 0;
  }

  &:hover {
    span {
      text-decoration: underline;
    }
  }
`;
